export default "__VITE_ASSET__BKKKrjzB__"